import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { tokenStore } from "@/lib/api";
import { trySilentSso } from "@/lib/silentSso";
import { planGate } from "@/lib/planGate";
import { installAuthFetch } from "@/lib/api";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

installAuthFetch();
trySilentSso({ hasToken: () => !!tokenStore.get(), setToken: (t) => tokenStore.set(t) });

// A free account that opens a paid app's address directly gets an upgrade notice, not the app.
planGate({ product: "hifz", getToken: () => tokenStore.get() }).then((ok) => {
  if (!ok) return;
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
});

// Registers the app-shell service worker (see public/sw.js) so the browser
// recognizes the site as installable and the "Download App" button
// (InstallAppButton.jsx) can trigger the native PWA install prompt.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
